/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.7.6",
    versionName: "0.4.0-nightly.2026.7.6",
    versionChannel: "nightly",
    buildDate: "2026-07-06T00:31:58.400Z",
    commitHash: "0ceea116791864b2a2eeb14332d0f09364a6e96b",
};
